import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FaqPage.css";

export const FaqPage = () => {
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(-1);
  const navigate = useNavigate();

  const faqs = [
    {
      question: "Di cosa si occupa l'assistente AI Station Support?",
      answer:
        "AI Station Support, al momento, è progettato per rispondere a domande relative a Messaggi Smart Caring, Provvedimenti SOTI, Provvedimenti relativi ai Treni Regionali, VCO (Variazioni in Corso d'Orario), Notizie Infomobilità",
    },
    {
      question: "Qual è il periodo di riferimento?",
      answer: "A partire da Settembre 2025 fino ad oggi",
    },
  ];

  const handleSelectedQuestion = (i) => {
    selectedQuestionIndex === i
      ? setSelectedQuestionIndex(-1)
      : setSelectedQuestionIndex(i);
  };

  return (
    <div className="faq-page-container">
      <div className="faq-page">
        <div className="faq-page-header">
          <div className="faq-page-header-back" onClick={() => navigate(-1)}>
            <img
              className="faq-page-header-arrow"
              src="arrow2.svg"
              alt="arrow2"
            />

            <span className="faq-page-header-back-text">Indietro</span>
          </div>

          <h1 className="faq-page-title">F.A.Q.</h1>
          <h2 className="faq-page-subtitle">Domande popolari</h2>
        </div>

        <ul className="faq-page-dropdown-list">
          {faqs.map((faq, i) => (
            <li
              key={i}
              className={`faq-page-question-container ${
                selectedQuestionIndex === i ? "selected" : ""
              }`}
              onClick={() => handleSelectedQuestion(i)}
            >
              <div className="faq-page-question">
                <span>{faq.question}</span>
                <img
                  className={
                    selectedQuestionIndex === i
                      ? "faq-page-question-arrow selected"
                      : "faq-page-question-arrow"
                  }
                  src="arrow.svg"
                  alt="arrow"
                />
              </div>

              <div
                className={`faq-page-answer ${
                  selectedQuestionIndex === i ? "open" : ""
                }`}
              >
                <p className="faq-page-answer-inner">{faq.answer}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
